module.exports = "<div [formGroup]=\"form\" class=\"width-full\">\r\n  <select formControlName=\"triplatereasonid\" required>\r\n    <option [ngValue]=\"reason.triplatereasonid\" *ngFor=\"let reason of reasonsDelay\">{{reason.description}}</option>\r\n  </select>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/trip-reservations/reasons-delay/reasons-delay/reasons-delay.component.html
// module id = 2557
// module chunks = 66